import React from "react";
import { Route } from "react-router-dom";

import { Row, Col } from "reactstrap";

export default class Footer extends React.Component {
  render() {
    return (
      <div >
        <Row
          style={{
            background: "#e3e5e6",
            padding: "30px 9% 20px 9%",
            marginTop: "100px",
            fontSize: "100%",
            color: "#5c5d5e"
          }}
        >
          <p>
            Mutual fund investing involves risk; Principal loss is possible. There can be no guarantee that any strategy (risk management or otherwise) will be successful.
          </p>
          <p style = {{
            fontStyle: "italic",
            fontWeight: "bold"
          }}>
            Before investing, investors should carefully consider the Fund's investment objectives, risks,
            charges and expenses. The summary and statutory prospectus contain this and other important
            information about the investment company, and it may be obtained by calling 800-542-7888 or
            visiting https://congress-mutual-funds.web.app. Read the prospectus carefully before investing.
          </p>
          <p>
            The Congress Funds are registered for sale to residents of the
            United States, and information on this site is intended only for
            such persons. Nothing on this site should be considered a
            solicitation to buy or an offer to sell shares of any Congress Funds
            in any jurisdiction where the offer or solicitation would be
            unlawful under the securities laws of such jurisdiction.
          </p>
          <p>Quasar Distributors, LLC, distributor</p>
        </Row>
        <Row style={{ paddingTop: '40px', paddingBottom: "40px", background: "#244f80" }}>
          <Col className="mt-4 mb-4" style={{ marginLeft: "9%" }}>
            <a style={{ color: "lightgray", position: 'relative', zIndex: 10 }} target="_blank" href="/privacy">
              Privacy Policy
            </a>
          </Col>
          <Col style={{ color: "white", textAlign: 'right', lineHeight: '4px', paddingRight: "9%", position: "absolute" }}>
            <p>Congress Asset Management</p>
            <p>2 Seaport Lane, 5th Floor</p>
            <p>Boston, MA 02210</p>
            <a style={{ whiteSpace: "pre", color: "white" }} href="tel:8005427888">800.542.7888 </a>
            <p className="mt-3">© Congress Asset Management Company 2024</p>
          </Col>
        </Row>
        <Route
          path="/privacy"
          component={() => {
            window.location.href =
              "https://www.congressasset.com/wp-content/uploads/2026-CAM-Privacy-Proxy-Notice_Final.pdf";
            return null;
          }}
        />
      </div>
    );
  }
}
